// extracted by mini-css-extract-plugin
module.exports = {"item":"social-media-link_item__GC1h0"};